import Home from '@/components/page/Home';
import Client from '@/components/page/Client';
import Facturation from '@/components/page/Facturation';
import User from '@/components/page/User';
// Routes
const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Home
    },
    {
        path: '/client',
        name: 'client',
        component: Client
    },
    {
        path: '/facturation',
        name: 'facturation',
        component: Facturation
    },
    {
        path: '/user',
        name: 'user',
        component: User
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js